<template>
  <div class="top">
    <img :src="require('@/assets/img/svg/logo_top.svg')" class="top__logo" />
    <div class="top__title">
      {{ $t('header.title') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Top',
}
</script>

<style lang="scss" scoped>
.top {
  display: flex;
  align-items: center;
  background-color: $generic-color-bg;
  padding: 0 $gutter-sm;
  width: 100%;
  height: 100%;
  border-bottom: 6px solid map-get($generic-color-variants, 'measure');
  margin-right: 12px;

  @media (min-width: $screen-sm) {
    padding: 0 $gutter-md;
  }

  &__logo {
    height: 16px;

    @media (min-width: $screen-sm) {
      height: 32px;
    }
  }

  &__title {
    flex: 1;
    font-size: $font-size-default;
    font-weight: 800;
    text-align: center;

    @media (min-width: $screen-sm) {
      font-size: $font-size-icons;
    }
  }
}
</style>
